import moment, { Moment } from "moment";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";

/**
 * Handle simple telegram formatting
 */
export class BIGTransit {
  private _code: string = "";
  private _accessResult: string = "";
  private _date: string = ""; //formatted as DDMMMYYYY
  private _time: string = ""; //formatted as HHmmss
  private _telegram: string = "";
  private _uid: string = "";
  private _isLate: number = 0;

  set code(codeValue: string) {
    this._code = codeValue;
  }

  set isLate(lateValue: number) {
    this._isLate = lateValue;
  }

  set uid(uidValue: string) {
    this._uid = uidValue;
  }

  set accessResult(accessResultValue: string) {
    this._accessResult = accessResultValue;
  }

  set date(dateValue: string) {
    this._date = dateValue;
  }

  set time(timeValue: string) {
    this._time = timeValue;
  }

  get telegram(): string {
    return this._telegram;
  }

  get date(): string {
    return this._date;
  }

  get uid(): string {
    return this._uid;
  }

  set telegram(valueTelegram: string) {
    this._telegram = valueTelegram;
  }

  constructor() { }

  /**
   * Build telegram by object property
   */
  public buildTelegramByProps(): void {
    this.formatTelegramProperty(
      this._code,
      this._accessResult,
      this._date,
      this._time,
      this._uid
    );
    let dateTelegram: Moment = moment(
      this._date + this._time,
      "DDMMYYYYHHmmss"
    );

    this._telegram =
      this._code + this._uid + this._accessResult + this._date + this._time;

    let now: Moment = moment(new Date());
    let duration = moment.duration(now.diff(dateTelegram));
    if (
      duration.asSeconds() >
      Number(AppSettings.SECOND_TO_EXECUTE_ACTION_TELEGRAM)
    ) {
      this._isLate = 1;
    } else {
      this._isLate = 0;
    }
    this._telegram += this._isLate;
  }

  /**
   * Unpack telegram string to inner property
   *
   * @param code Numeric code
   * @param accessResult Access result value
   * @param date Date access
   * @param time time access
   */
  private formatTelegramProperty(
    code: string,
    accessResult: string,
    date: string,
    time: string,
    uid: string
  ): void {
    this._code = code.padStart(6, "0");
    this._uid = uid.padStart(8, "0");
    this._accessResult = accessResult.padStart(4, "0");
    this._date = date.padStart(8, "0");
    this._time = time.padStart(4, "0");
  }
}
